/**
 * Returns a random integer between optional min and max value \
 * default `max = Number.MAX_VALUE` \
 * default `min = 0`
 */
const randomInt = ({ max = Number.MAX_VALUE, min = 0 }) =>
    Math.round(Math.random() * (max - min)) + min;

export { randomInt };
